var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextjs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 15 15",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 7.5c0-4.14214 3.35786-7.5 7.5-7.5 4.1421 0 7.5 3.35786 7.5 7.5 0 2.587-1.3098 4.8681-3.3025 6.2163l-6.79063-9.50688c-.12634-.17687-.35247-.25186-.55946-.18553s-.34741.25879-.34741.47615v7.49996h1v-5.93973l5.8299 8.16183c-1.00329.498-2.1339.7779-3.3299.7779-4.14214 0-7.5-3.3579-7.5-7.5zm10 2.5v-6h1v6z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs2);
export default __webpack_public_path__ + "static/media/nextjs-2.badbbbf8aa9b84b1f447dd7fe5a7729d.svg";
export { ForwardRef as ReactComponent };